import React from 'react'

const MyMessages = () => {
  return (
    <div>MyMessages</div>
  )
}

export default MyMessages;